var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.251,
    height: 15.252,
    viewBox: "0 0 15.251 15.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00959c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.711,19.406a.317.317,0,0,1-.312-.379l.449-2.246a.311.311,0,0,1,.087-.163l4.943-4.943a.955.955,0,0,1,1.348,0l.9.9a.954.954,0,0,1,0,1.348l-4.943,4.943a.316.316,0,0,1-.163.087l-2.246.449A.337.337,0,0,1,11.711,19.406ZM12.454,17l-.337,1.685,1.685-.337,4.875-4.875a.318.318,0,0,0,0-.449l-.9-.9a.318.318,0,0,0-.449,0Zm1.5,1.641h.006Z",
    transform: "translate(-4.153 -4.154)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.037,14.439H1.589A1.59,1.59,0,0,1,0,12.85V4.589A1.59,1.59,0,0,1,1.589,3H2.86a.318.318,0,0,1,0,.635H1.589a.954.954,0,0,0-.953.953V12.85a.954.954,0,0,0,.953.953H6.037a.318.318,0,0,1,0,.635Z",
    transform: "translate(0 -1.094)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.86,8.719a.318.318,0,0,1-.318-.318V4.589a.954.954,0,0,0-.953-.953H12.318a.318.318,0,0,1,0-.635h1.271a1.59,1.59,0,0,1,1.589,1.589V8.4A.318.318,0,0,1,14.86,8.719Z",
    transform: "translate(-4.374 -1.094)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.766,3.813H4.953A.954.954,0,0,1,4,2.86V1.589a.318.318,0,0,1,.318-.318H5.3a1.589,1.589,0,0,1,3.114,0H9.4a.318.318,0,0,1,.318.318V2.86A.954.954,0,0,1,8.766,3.813ZM4.635,1.906V2.86a.319.319,0,0,0,.318.318H8.766a.319.319,0,0,0,.318-.318V1.906H8.131a.318.318,0,0,1-.318-.318.953.953,0,1,0-1.906,0,.318.318,0,0,1-.318.318Z",
    transform: "translate(-1.458)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.673,8.635H3.318a.318.318,0,1,1,0-.635H9.673a.318.318,0,1,1,0,.635Z",
    transform: "translate(-1.094 -2.916)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.673,11.635H3.318a.318.318,0,1,1,0-.635H9.673a.318.318,0,1,1,0,.635Z",
    transform: "translate(-1.094 -4.01)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.673,14.635H3.318a.318.318,0,1,1,0-.635H9.673a.318.318,0,1,1,0,.635Z",
    transform: "translate(-1.094 -5.103)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.d362536a3aa3d627fe86aff44231415b.svg";
export { ForwardRef as ReactComponent };